// extracted by mini-css-extract-plugin
export default {"container":"EvidenceSection_container__lnOBR","wrapperImg":"EvidenceSection_wrapperImg__pZk0T","box":"EvidenceSection_box__3-jc1"};